import React, { useRef, useState, useEffect, useContext, forwardRef, useImperativeHandle } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { OrbitControls, useTexture, Text, Billboard } from '@react-three/drei';
import * as THREE from 'three';
import { Euler } from 'three';
import TWEEN from '@tweenjs/tween.js';
import { StateContext } from './StateContext';
import axios from 'axios';

const Sphere = forwardRef(({ leftValue }, ref) => {
  const sphereRef = useRef();
  const textRef = useRef([])
  const texture = useTexture('/globetexture.jpg');
  const { camera } = useThree();
  const { targetCity, setTargetCity } = useContext(StateContext);
  const [cityClicked, setCityClicked] = useState(false);

  const [spherePosition, setSpherePosition] = useState([0, 0, 0]);
  // const [fontSize, setFontSize] = useState(0.02);

  const [cities, setCities] = useState([]);





  // Array of city coordinates
  const dummyCities = [
    { city: "Karachi", latitude: 24.8607, longitude: 67.0011 },
    { city: "New York", latitude: 40.7128, longitude: -74.0060 },
    { city: "London", latitude: 51.5074, longitude: -0.1278 },
    { city: "Tokyo", latitude: 35.6895, longitude: 139.6917 },
    { city: "Sydney", latitude: -33.8688, longitude: 151.2093 },
    { city: "Paris", latitude: 48.8566, longitude: 2.3522 },
    { city: "Moscow", latitude: 55.7558, longitude: 37.6173 },
    { city: "Rio", latitude: -22.9068, longitude: -43.1729 },
    { city: "Cairo", latitude: 30.0444, longitude: 31.2357 },
    { city: "Beijing", latitude: 39.9042, longitude: 116.4074 },
    { city: "Los Angeles", latitude: 34.0522, longitude: -118.2437 },
    { city: "Buenos Aires", latitude: -34.6037, longitude: -58.3816 },
    { city: "Cape Town", latitude: -33.9249, longitude: 18.4241 },
    { city: "Dubai", latitude: 25.276987, longitude: 55.296249 },
    { city: "Mumbai", latitude: 19.0760, longitude: 72.8777 },
    { city: "Istanbul", latitude: 41.0082, longitude: 28.9784 },
    { city: "Mexico City", latitude: 19.4326, longitude: -99.1332 },
    { city: "Bangkok", latitude: 13.7563, longitude: 100.5018 },
    { city: "Toronto", latitude: 43.651070, longitude: -79.347015 },
    { city: "Seoul", latitude: 37.5665, longitude: 126.9780 },
    { city: "Singapore", latitude: 1.3521, longitude: 103.8198 },
    { city: "Berlin", latitude: 52.5200, longitude: 13.4050 }
  ];


  // Function to convert latitude/longitude to Cartesian coordinates
  const latLongToVector3 = (latitude, longitude, radius) => {
    const phi = (90 - latitude) * (Math.PI / 180);
    const theta = (longitude + 180) * (Math.PI / 180);

    const x = -((radius) * Math.sin(phi) * Math.cos(theta));
    const y = ((radius) * Math.cos(phi));
    const z = ((radius) * Math.sin(phi) * Math.sin(theta));

    return [x, y, z];
  };

  const focusOnCity = (city) => {
    const [x, y, z] = latLongToVector3(city.latitude, city.longitude - 30 , 1.75); // Adjust the radius as needed

    new TWEEN.Tween(camera.position)
      .to({ x, y, z }, 2000) // Transition to the new position over 2 seconds
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onUpdate(() => {
        camera.lookAt(0, 0, 0); // Ensure the camera looks at the center
      })
      .start();

    setCityClicked(true);
    setTargetCity(city);
    leftValue(-1000);
  };

  const handleExit = (city) => {
    const [x, y, z] = latLongToVector3(city.latitude, city.longitude, 2); // Adjust the radius as needed


    new TWEEN.Tween(camera.position)
      .to({ x, y, z }, 2000) // Transition to the new position over 2 seconds
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onUpdate(() => {
        camera.lookAt(0, 0, 0); // Ensure the camera looks at the center
      })
      .start();

    setCityClicked(false);
    setTargetCity(null);



    leftValue(0);

  }


 


  useImperativeHandle(ref, () => ({
    handleExit,
  }));
  const [loading, setLoading] = useState(false)
  // { headers: { "ngrok-skip-browser-warning": "69420" } } after comma in api link
  useEffect(() => {
    setLoading(true)
    axios.get('https://nice-blackburn.23-106-85-134.plesk.page/api/churches/list',)
      .then(response => {
        console.log("======", response.data.data);
        setCities(response.data.data);
        setLoading(false);
      })
      .catch(error => {
        console.log("error===", error);
      });


  }, []);


  // console.log(cities)

  useEffect(() => {
    camera.position.set(0, 0, 2);
  }, [targetCity, setTargetCity]);

  // useEffect(() => {
  //   if (targetCity) {
  //     focusOnCity(targetCity);
  //   }
  // }, [targetCity]);

  useFrame(() => {
    if (loading) return;
    TWEEN.update();
    if (!cityClicked && sphereRef.current) {
      // sphereRef.current.rotation.y += 0.001; // Auto Rotate
    }
    textRef.current.forEach((textRef) => {
      if (textRef) {
        textRef.quaternion.copy(camera.quaternion);
      }
    });
  });



  return (
    <>
 <mesh ref={sphereRef} position={spherePosition}>
        <sphereGeometry args={[1, 64, 64]} color={'#fff'} emissive={'#FFF'} emissiveIntensity={4} />

        <meshMatcapMaterial map={texture} />
        {cities?.map((city, index) => {
          const [x, y, z] = latLongToVector3(city.latitude, city.longitude, 1);
          const [x1, y1, z1] = latLongToVector3(city.latitude, city.longitude, 1.03);
          const [x2, y2, z2] = latLongToVector3(city.latitude, city.longitude, 1.06);
          console.log(`Rendering text for ${city.city} at position:`, typeof Number(city.latitude), city.longitude,);
          return (
            <group >
              <mesh key={index} position={[x, y, z]}
                onClick={() => {
                  if (!cityClicked) {
                    setTargetCity(city);
                    focusOnCity(city);
                  }
                }}
                onPointerOver={() => {
                  if (!cityClicked) {
                    document.body.style.cursor = 'pointer';
                  }
                }}

                onPointerOut={() => (document.body.style.cursor = 'auto')}
              >
                <sphereGeometry args={[0.01, 32, 32]} />
                {/* Point */}
                <meshBasicMaterial color="red" />
              </mesh>

              <Text ref={(ref) => (textRef.current[index] = ref)}
                position={targetCity?.city === city?.city ? [x2, y2, z2] : [x1, y1, z1]}
                fontSize={targetCity?.city === city?.city ? 0.04 : 0.02}
                color="white"
                anchorX="center"
                anchorY="middle"
                outlineWidth={0.001}
                outlineColor="black"

              >

                {city.city}
              </Text>




            </group>
          );
        })}
      </mesh>
        <OrbitControls
          enablePan={false}
          maxPolarAngle={Math.PI / 2 + 10}
          minPolarAngle={0}
          minDistance={1.5}
          maxDistance={4}
          enableZoom={false}
          enableRotate={!cityClicked}
        />
    </>
  );
});




export default Sphere;
